import { render } from "./ParagraphFullhtml.vue?vue&type=template&id=c2dc9af4&ts=true"
import script from "./ParagraphFullhtml.vue?vue&type=script&lang=ts"
export * from "./ParagraphFullhtml.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__